'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.minutesFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/minutesFromNow.js
// module id = 574
// module chunks = 0